import { RootState } from 'rootReducer';

export const selectIsOnboarding = (state: RootState) =>
  state.ui.apps.survey.onboarding.home.isOnboarding;

export const selectSuccessRedirectUrl = (state: RootState) =>
  state.ui.apps.survey.onboarding.home.redirect_to;
